import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

export default function VideosGrid() {
  const { selected } = useProvince();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/videos?limit=4${selected ? `&province_id=${selected.id}` : ""}`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, [selected?.id]);
  if (!items.length) return null;
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-1 h-6 bg-[#e11d2a] rounded-full"></div>
          <h3 className="text-lg font-black">VİDEO İÇERİKLER</h3>
        </div>
        <Link to="/video" className="text-xs font-semibold text-[#e11d2a] hover:underline">Tümünü Gör →</Link>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {items.slice(0, 4).map((v) => (
          <Link key={v.id} to={`/video/${v.id}`} className="group relative aspect-video overflow-hidden rounded-lg bg-black">
            <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-12 h-12 rounded-full bg-[#e11d2a]/95 flex items-center justify-center group-hover:scale-110 transition-transform">
                <Play className="w-6 h-6 text-white" fill="white" />
              </div>
            </div>
            <div className="absolute bottom-2 left-3 right-3 text-white text-xs md:text-sm font-semibold line-clamp-2">{v.title}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
